<template>
  <b-card
    :class="['kpi-card', 'border-0', 'shadow-sm', 'w-100', cardBgClass]"
    no-body
    role="button"
    tabindex="0"
  >
    <b-card-body>
      <h6 class="card-title text-white mb-2">{{ title }}</h6>
      <div class="d-flex justify-content-between align-items-center">
        <span class="display-6 text-white text-truncate mr-1">{{ value }}</span>
        <i v-if="trend !== null" :class="trendIconClass" class="bi text-white flex-shrink-0"></i>
      </div>
      <div v-if="subtitle" class="small mt-1 text-white">
        {{ subtitle }}
      </div>
      <div class="small mt-1">
        <template v-if="trend !== null">
          <span :class="trendTextClass">{{ formattedTrend }}%</span>
          <span class="text-white"> vs Yesterday</span>
        </template>
        <span v-else class="text-white-50">No previous data</span>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'KpiCard',
  components: {
    BCard,
    BCardBody,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    trend: {
      type: [Number, null],
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    cardBgClass() {
      const map = {
        'blue darken-1': 'bg-primary',
        'green darken-1': 'bg-success',
        'orange darken-1': 'bg-warning',
        'purple darken-1': 'bg-info',
        'red darken-1': 'bg-danger',
        'amber darken-1': 'bg-warning',
        'blue-grey darken-1': 'bg-secondary',
        'grey darken-3': 'bg-dark',
        'teal darken-1': 'bg-info',
        'cyan darken-1': 'bg-info',
        'light-green darken-1': 'bg-success',
        'indigo darken-1': 'bg-primary',
        primary: 'bg-primary',
        success: 'bg-success',
        warning: 'bg-warning',
        info: 'bg-info',
      };
      return map[this.color] || 'bg-primary';
    },
    trendIconClass() {
      if (this.trend === null) return '';
      return this.trend >= 0 ? 'bi-arrow-up-right' : 'bi-arrow-bottom-left';
    },
    trendTextClass() {
      if (this.trend === null) return '';
      return this.trend >= 0 ? 'text-success' : 'text-danger';
    },
    formattedTrend() {
      if (this.trend === null) return 'N/A';
      return Math.abs(this.trend).toFixed(2);
    },
  },
};
</script>

<style scoped>
/* Match PresalesProgressCard spacing (same file: margin 10px on presales-progress-card) */
.kpi-card {
  cursor: pointer;
  margin: 10px;
}
</style>
